module.exports = __webpack_public_path__ + "media/assets/images/flags/at-b31895044f05455ff042ab9443e52c08.svg";